// extracted by mini-css-extract-plugin
export default {"btn":"RedButton_btn__rFC6h","count":"RedButton_count__vikwP"};